import { Flex, Stack, Text } from '@mantine/core'

import styles from './modal.module.scss'
import { MODAL_COLOR, MODAL_ICON } from './modalConfig'
import { EnumModalIcons, EnumModalType } from './types'

export type AppModalContentProps = {
  title: string
  subtitle?: string
  Icon?: EnumModalIcons
  type?: EnumModalType
  titleColor?: string
}

const AppModalContent = ({
  title,
  subtitle,
  titleColor = 'black',
  Icon = EnumModalIcons.Check,
  type = EnumModalType.SUCCESS,
}: AppModalContentProps) => {
  return (
    <Stack justify="center" gap="15px" align="center" maw="100%">
      <Flex className={styles.icon} bg={MODAL_COLOR[type]}>
        {MODAL_ICON[Icon]}
      </Flex>
      <Text fz="22px" lh="130%" fw="700" ta="center" mt="md" c={titleColor}>
        {title}
      </Text>
      <Text
        mb="sm"
        fz="15px"
        lh="130%"
        fw="400"
        c="var(--mantine-color-gray-9)"
        ta="center"
      >
        {subtitle}
      </Text>
    </Stack>
  )
}

export default AppModalContent
